var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333132",
    fillRule: "evenodd",
    d: "M15.026 16.875c1.02 0 1.849-.83 1.849-1.85V11.25h.563c.309 0 .562-.253.562-.562v-4.5c0-.932-.756-1.688-1.687-1.688h-.918c.218-.425.355-.896.355-1.406A3.1 3.1 0 0 0 12.656 0c-1.462 0-2.408.749-3.62 2.401C7.821.75 6.875 0 5.413 0A3.1 3.1 0 0 0 2.32 3.094c0 .51.134.98.355 1.406h-.987C.756 4.5 0 5.256 0 6.187v4.5c0 .31.253.563.562.563h.563v3.776c0 1.02.83 1.849 1.85 1.849zM8.437 4.5H5.411a1.406 1.406 0 1 1 0-2.812c.773 0 1.318.267 2.956 2.707zm4.22 0H9.628l.07-.105c1.639-2.44 2.184-2.707 2.957-2.707a1.406 1.406 0 1 1 0 2.812m-4.5 10.688H2.973a.16.16 0 0 1-.162-.162V11.25H6.75V9.562H1.688V6.187h6.468zm6.869 0H9.844v-9h6.469v3.374H11.25v1.688h3.938v3.776c0 .088-.07.162-.162.162",
    clipRule: "evenodd"
  })));
};
export default SvgGift;